import tw from "src/utils/tw";

export default function ItemMenu(props) {
  return (
    <div className={tw("relative float-right mb-2 ml-2", props.className)}>
      {props.children}
    </div>
  );
}
